module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Document Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wrapper col-md-12"
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.gridSpec.tableData,
      "columns": _vm.gridSpec.columns,
      "options": _vm.gridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "view",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.viewRecord(props.row)
            }
          }
        })])]
      }
    }, {
      key: "download",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-cloud-download",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.downloadMedia(props.row)
            }
          }
        })])]
      }
    }, {
      key: "archive",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.archiveMedia(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e09f4c50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaNotification.vue
// module id = 995
// module chunks = 1